export default __webpack_public_path__ + "static/media/gallery_00.e11310f8.jpg";